// import CityzensWidgets from './cityzens-widgets';
import MatchDayCardWidgets from './match-day-card-widgets';

export default [
  // new CityzensWidgets(),
  new MatchDayCardWidgets(),
];
